module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "a5"
    }
  }, [_c('span', [_c('i', [_vm._v("Times Square")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e171413"
    }
  }, [_c('span', [_vm._v("Instead of making a variation of Charming Flowers, we made a different quilt that uses the same technique. Again it is squares sewn together with clever placement of half-square triangle units to create the artistic design.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e172713"
    }
  }, [_c('span', [_vm._v("We have used two charm packs from Moda’s range Charisma by Chez Moi, which gives a lovely colourwash effect, together with two neutral charm packs. You could of course use one layer cake cut into 5in squares as long as there were sufficient lights to create the design.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#dbd0cd",
      "border": "thin white solid",
      "border-color": "#936664",
      "margin-top": "1em"
    }
  }, [_c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e174313"
    }
  }, [_c('span', [_c('i', [_vm._v("What you need")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#f9f7f6",
      "border": "thin white solid",
      "border-color": "#936664"
    }
  }, [_c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e174813"
    }
  }, [_c('span', [_vm._v("• Four charm packs – two lights and two darks (you need seventy-two of each for this quilt and will have eight of each spare for another project)")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d9t00013"
    }
  }, [_c('span', [_vm._v("• Six fat quarters (three light and three dark) for half-square triangles")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d9t00113"
    }
  }, [_c('span', [_vm._v("• 20in (50cm) for binding")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0013_001",
      "src": "images/9780715332085_0013_001.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e179113"
    }
  }, [_c('span', [_c('i', [_vm._v("Cutting Instructions")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e179613"
    }
  }, [_c('span', [_c('b', [_vm._v("Binding fabric:")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e180313"
    }
  }, [_c('span', [_vm._v("• Cut seven strips 2½in wide across the width of the fabric.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e181713"
    }
  }, [_c('span', [_c('b', [_vm._v("Seam allowance:")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e182413"
    }
  }, [_c('span', [_vm._v("• Use scant ¼in seams throughout.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e183413"
    }
  }, [_c('span', [_c('i', [_vm._v("Making the Half-square Triangle Units")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e184213"
    }
  }, [_c('span', [_c('b', [_vm._v("1. ")]), _vm._v("Refer to the instructions for making half-square triangle units on page 10 and layer a dark and light fat quarter.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e185713"
    }
  }, [_c('span', [_c('b', [_vm._v("2. ")]), _vm._v("You only need to cut nine squares from each fat quarter, so cut three strips each 53/8in wide and then sub-cut each strip into three squares each 53/8in x 53/8in.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0013_002",
      "src": "images/9780715332085_0013_002.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e190313"
    }
  }, [_c('span', [_c('b', [_vm._v("3. ")]), _vm._v("Repeat with the other dark and light fat quarters. You need fifty-two half-square triangles in total (two are spare).")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#f9f7f6",
      "border": "thin white solid",
      "border-color": "#936664",
      "margin-top": "1em"
    }
  }, [_c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e191813"
    }
  }, [_c('span', [_c('i', [_vm._v("Vital statistics")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#dbd0cd",
      "border": "thin white solid",
      "border-color": "#936664"
    }
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "border": "0"
    }
  }, [_c('colgroup', [_c('col'), _c('col')]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Quilt size:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("63in x 63in")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Block size:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("4½in")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Number of blocks:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("196")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Setting:")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("14 x 14 blocks")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e192513"
    }
  }, [_c('span', [_c('i', [_vm._v("Assembling your Quilt")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e193013"
    }
  }, [_c('span', [_vm._v("• Lay out all your light and dark charm squares in fourteen rows of fourteen (see diagram below for placing the squares and half-square triangles).")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e194613"
    }
  }, [_c('span', [_vm._v("• When you are happy with the layout, label the first square of each row with the row number, to ensure they stay in the correct order after sewing.")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e196313"
    }
  }, [_c('span', [_vm._v("• Sew the squares into rows and then join the rows together, pinning at every intersection to ensure a perfect match. Press the work.")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e198113"
    }
  }, [_c('span', [_vm._v("• Your quilt top is now complete. Quilt as desired and bind to finish (see "), _c('span', {
    attrs: {
      "href": "#/Lint_9780715332085_epub_c25_r1#d7e18035131",
      "id": "d14e505",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quilting")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0013_003",
      "src": "images/9780715332085_0013_003.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e199813"
    }
  }, [_c('span', [_vm._v("opposite:"), _c('br'), _c('b', [_c('i', [_vm._v("Charisma by Chez Moi gave us just the colourwash effect we wanted for this quilt. We chose a distinctive quilting design called ‘Splat’ – a fun design for a fun quilt. The quilt was pieced by the authors and longarm quilted by The Quilt Room.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0014_001",
      "src": "images/9780715332085_0014_001.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9780715332085_0014_002",
      "src": "images/9780715332085_0014_002.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61fdc07c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lint_9780715332085_epub_c7_r1.vue
// module id = 81
// module chunks = 0